import { useRootMemoSelector } from 'use-redux-states';

export const useUser = (selector = (user) => user) => useRootMemoSelector('auth.user', selector);
